import { useState, useEffect } from "react";
import { getUserBalance } from "../services/balance";
import { getCommoditiesList } from "../services/commodities";
import { useMediaQuery } from "react-responsive";
import { toPersianNum } from "../utils/persianNumbers";

export default function ScrollOnMainPage() {
  const [transations, setTransactions] = useState([]);
  const [commodities, setCommodities] = useState([]);
  const isTabletOrfirst = useMediaQuery({ query: "(max-width: 768px)" });
  useEffect(() => {
    getCommoditiesList().then((res) => {
      const commodityList = res?.data?.results;
      setCommodities(commodityList);
      const result = [];
      let counter = 1;
      for (let commodity of commodityList) {
        getUserBalance(commodity.id).then(({ data }) => {
          if (data && data.data) {
            if (commodity.id == "1") {
              result.push({
                id: "1",
                label: "موجودی تومانی",
                amount: data.data.cash_balance,
                color: commodity?.ui_data?.colors?.primary,
                icon: commodity?.ui_data?.icons?.primary,
                unit_name: commodity?.ui_data?.unit_name,
              });
              result.push({
                id: "2",
                label: "تومان بلوکه",
                amount: data.data.useless_cash_amount,
                color: commodity?.ui_data?.colors?.primary,
                icon: commodity?.ui_data?.icons?.primary,
                unit_name: commodity?.ui_data?.unit_name,
              });
            }
            result.push({
              id: `${Number(commodity.id) + counter}`,
              label: `موجودی ${toPersianNum(commodity.name)}`,
              amount: data.data.gold_balance,
              color: commodity?.ui_data?.colors?.primary,
              icon: commodity?.ui_data?.icons?.primary,
              unit_name: commodity?.ui_data?.unit_name || " گرم",
            });
            result.push({
              id: `${Number(commodity.id) + counter + 1}`,
              label: `${toPersianNum(commodity.name)} بلوکه شده`,
              amount: data.data.useless_gold_amount,
              color: commodity?.ui_data?.colors?.primary,
              icon: commodity?.ui_data?.icons?.primary,
              unit_name: commodity?.ui_data?.unit_name || " گرم",
            });
            counter = counter + 2;

            if (result.length === commodityList.length * 2 + 2) {
              const sortedList = [...result].sort(
                (a, b) => Number(a.id) - Number(b.id)
              );
              setTransactions([...sortedList]);
            }
          }
        });
      }
    });
  }, [isTabletOrfirst]);
  return (
    <div className="scroll">
      <div className="info-box-wrapper-mobile">
        {isTabletOrfirst
          ? transations.map(
              (item) =>
                item.label != "موجودی تومانی" &&
                item.label != "تومان بلوکه" && (
                  <div className={"info-box-mobile"}>
                    <div
                      className="price-items bigger-items-amount"
                      style={{
                        color: `${item.color}`,
                      }}
                    >
                      {new Intl.NumberFormat("fa", {
                        maximumFractionDigits: 3,
                      }).format(item.amount)}{" "}
                      {item?.unit_name}
                    </div>
                    <span
                      style={{
                        color: `${item.color}`,
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                )
            )
          : transations.map((item) => (
              <div className={"info-box-mobile"}>
                <div
                  className="price-items bigger-items-amount"
                  style={{
                    color: `${item.color}`,
                  }}
                >
                  {new Intl.NumberFormat("fa", {
                    maximumFractionDigits: 3,
                  }).format(item.amount)}{" "}
                  {item.unit_name}
                </div>
                <span
                  style={{
                    color: `${item.color}`,
                  }}
                >
                  {item.label}
                </span>
              </div>
            ))}
      </div>
    </div>
  );
}
